/**
 * Grillion cookie banner helper:
 * - Hides the main cookie banner when the preferences dialog is opened to prevent overlapping.
 * - Perfectly aligns each preference category's title and description text.
 * - Does NOT alter any content, text, or buttons (Shopify default content is fully preserved).
 * - Fully compatible with Safari and all modern browsers.
 */
(function () {
  'use strict';

  var BANNER_ID = 'shopify-pc__banner';
  var PREFS_ID = 'shopify-pc__prefs__dialog';
  var OPEN_CLASS = 'shopify-pc__prefs-open';

  function alignPreferenceText() {
    var prefs = document.getElementById(PREFS_ID);
    if (!prefs) return;

    var checkboxes = prefs.querySelectorAll('input[type="checkbox"]');
    if (!checkboxes || !checkboxes.length) return;

    for (var i = 0; i < checkboxes.length; i++) {
      var cb = checkboxes[i];
      var item =
        cb.closest('[class*="item"], [class*="category"], [class*="group"], [class*="field"], [class*="option"], [class*="row"], fieldset, li') ||
        cb.parentElement.parentElement;
      if (!item) continue;

      // Find title/label
      var label = null;
      if (cb.id) {
        label = prefs.querySelector('label[for="' + cb.id + '"]');
      }
      if (!label) {
        label = cb.closest('label');
      }
      if (!label) {
        label = item.querySelector('label, [class*="title"], [class*="name"], [class*="heading"], h3, h4, h5');
      }

      // Find description paragraph
      var paragraphs = item.querySelectorAll('p');
      var desc = null;
      for (var p = 0; p < paragraphs.length; p++) {
        var para = paragraphs[p];
        if (
          !para.closest('[class*="intro"]') &&
          !para.classList.contains('shopify-pc__prefs__intro-main')
        ) {
          desc = para;
          break;
        }
      }

      if (!label || !desc) continue;

      // Ensure text is left-aligned
      label.style.setProperty('text-align', 'left', 'important');
      desc.style.setProperty('text-align', 'left', 'important');
      desc.style.setProperty('text-indent', '0px', 'important');

      // Check if label and desc share a common content wrapper that does NOT contain the checkbox
      var labelParent = label.parentElement;
      var descParent = desc.parentElement;
      if (labelParent === descParent && !labelParent.contains(cb)) {
        label.style.setProperty('margin-left', '0px', 'important');
        label.style.setProperty('padding-left', '0px', 'important');
        desc.style.setProperty('margin-left', '0px', 'important');
        desc.style.setProperty('padding-left', '0px', 'important');
        continue;
      }

      // Determine where the text inside label begins
      var textLeft = 0;
      var cbRect = cb.getBoundingClientRect();

      if (label.contains(cb)) {
        var foundChild = null;
        for (var c = 0; c < label.childNodes.length; c++) {
          var node = label.childNodes[c];
          if (node !== cb && !node.contains(cb) && node.textContent.trim().length > 0) {
            foundChild = node;
            break;
          }
        }
        if (foundChild) {
          if (foundChild.nodeType === 3) {
            try {
              var range = document.createRange();
              range.selectNodeContents(foundChild);
              var r = range.getBoundingClientRect();
              if (r && r.width > 0) textLeft = r.left;
            } catch (err) {}
          } else if (foundChild.getBoundingClientRect) {
            textLeft = foundChild.getBoundingClientRect().left;
          }
        }
        if (!textLeft) {
          textLeft = cbRect.right + 10;
        }
      } else {
        textLeft = label.getBoundingClientRect().left;
      }

      if (textLeft > 0) {
        var descRect = desc.getBoundingClientRect();
        var currentMargin = parseFloat(window.getComputedStyle(desc).marginLeft) || 0;
        var diff = descRect.left - textLeft;
        if (Math.abs(diff) > 0.5) {
          desc.style.setProperty('padding-left', '0px', 'important');
          desc.style.setProperty('margin-left', (currentMargin - diff) + 'px', 'important');
        }
      }
    }
  }

  function updateState() {
    var banner = document.getElementById(BANNER_ID);
    var prefs = document.getElementById(PREFS_ID);
    if (!prefs) return;

    var isOpen =
      prefs.hasAttribute('open') ||
      (prefs.offsetWidth > 0 && prefs.offsetHeight > 0 && window.getComputedStyle(prefs).display !== 'none');

    if (isOpen) {
      document.body.classList.add(OPEN_CLASS);
      if (banner) {
        banner.style.setProperty('display', 'none', 'important');
        banner.setAttribute('aria-hidden', 'true');
      }
      alignPreferenceText();
      setTimeout(alignPreferenceText, 40);
      setTimeout(alignPreferenceText, 120);
      setTimeout(alignPreferenceText, 250);
    } else {
      document.body.classList.remove(OPEN_CLASS);
      if (banner) {
        banner.style.removeProperty('display');
        banner.removeAttribute('aria-hidden');
      }
    }
  }

  function init() {
    var prefs = document.getElementById(PREFS_ID);
    if (prefs) {
      prefs.addEventListener('close', updateState);
      prefs.addEventListener('cancel', updateState);

      if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(updateState);
        observer.observe(prefs, {
          attributes: true,
          attributeFilter: ['open', 'style', 'class', 'hidden'],
        });
      }
    }

    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        if (!target) return;
        if (
          target.id === 'shopify-pc__banner__btn-manage-prefs' ||
          target.closest('#shopify-pc__banner__btn-manage-prefs') ||
          target.closest('[class*="manage-prefs"]')
        ) {
          setTimeout(updateState, 10);
          setTimeout(updateState, 80);
          setTimeout(updateState, 200);
        }
        if (
          target.closest('#shopify-pc__prefs__dialog') ||
          target.closest('[class*="prefs"]')
        ) {
          setTimeout(updateState, 50);
          setTimeout(updateState, 150);
          setTimeout(updateState, 300);
        }
      },
      true
    );

    window.addEventListener('resize', function () {
      var prefs = document.getElementById(PREFS_ID);
      if (prefs && (prefs.hasAttribute('open') || prefs.offsetWidth > 0)) {
        alignPreferenceText();
      }
    });

    updateState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof MutationObserver !== 'undefined' && document.body) {
    var bodyObserver = new MutationObserver(function () {
      if (document.getElementById(PREFS_ID)) {
        updateState();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
